import { cx } from "../../lib/cx.js";
import { Breadcrumb } from "../Breadcrumb/Breadcrumb.js";
/* empty css               */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/PageHeader/PageHeader.tsx
/**
* The top of a page's content: an optional breadcrumb, the title (the page's `h1`) and
* subtitle, the page's actions, and an optional footer. Put it first in AppShell's
* content.
*/
function PageHeader({ title, subtitle, breadcrumb, actions, media, footer, className, ...rest }) {
	return /* @__PURE__ */ jsxs("div", {
		...rest,
		className: cx("ds-page-header", className),
		children: [
			Array.isArray(breadcrumb) ? /* @__PURE__ */ jsx(Breadcrumb, { items: breadcrumb }) : breadcrumb,
			/* @__PURE__ */ jsxs("div", {
				className: "ds-page-header__row",
				children: [
					media && /* @__PURE__ */ jsx("div", {
						className: "ds-page-header__media",
						children: media
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "ds-page-header__titles",
						children: [/* @__PURE__ */ jsx("h1", {
							className: "ds-page-header__title",
							children: title
						}), subtitle && /* @__PURE__ */ jsx("p", {
							className: "ds-page-header__subtitle",
							children: subtitle
						})]
					}),
					actions && /* @__PURE__ */ jsx("div", {
						className: "ds-page-header__actions",
						children: actions
					})
				]
			}),
			footer && /* @__PURE__ */ jsx("div", {
				className: "ds-page-header__footer",
				children: footer
			})
		]
	});
}
//#endregion
export { PageHeader };

//# sourceMappingURL=PageHeader.js.map